import { getHotSites } from '@/mocks/sites';
import { categories } from '@/mocks/categories';

export default function HotSites() {
  const hotSites = getHotSites(12);
  const categoryMap = Object.fromEntries(categories.map((c) => [c.slug, c]));

  return (
    <section className="py-14 md:py-18 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-600">
              最受用户欢迎的精选站点，品质之选
            </p>
          </div>
          <div className="hidden sm:flex items-center gap-1 text-xs text-foreground-400">
            <i className="ri-fire-line text-accent-500"></i>
            <span>实时热门榜单</span>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {hotSites.map((site, index) => {
            const cat = categoryMap[site.categorySlug];
            return (
              <a
                key={site.id}
                href={site.url}
                target="_blank"
                rel="nofollow noopener"
                className="group p-4 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-300 transition-all duration-300 cursor-pointer"
              >
                <div className="flex items-start justify-between mb-3">
                  <div className="flex items-center gap-2">
                    {index < 3 && (
                      <span className="w-5 h-5 flex items-center justify-center bg-accent-500 text-background-50 text-xs font-bold rounded">
                        {index + 1}
                      </span>
                    )}
                    <h3 className="text-sm font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                      {site.name}
                    </h3>
                  </div>
                  <div className="flex items-center gap-1 text-accent-500">
                    <i className="ri-star-fill text-xs"></i>
                    <span className="text-xs font-medium">{site.rating}</span>
                  </div>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                  {site.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded">
                    {cat?.name || site.categorySlug}
                  </span>
                  <div className="flex flex-wrap gap-1">
                    {site.tags.slice(0, 2).map((tag) => (
                      <span
                        key={tag}
                        className="text-[11px] text-secondary-600 bg-secondary-100 px-1.5 py-0.5 rounded"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}